import { render } from "./GalleryPage.vue?vue&type=template&id=af030e78&scoped=true"
import script from "./GalleryPage.vue?vue&type=script&lang=js"
export * from "./GalleryPage.vue?vue&type=script&lang=js"

import "./GalleryPage.vue?vue&type=style&index=0&id=af030e78&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af030e78"]])

export default __exports__